<template>
  <div class="picBox">
        <!-- 返回标题 -->
    <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/productMainList' }">全部产品列表</el-breadcrumb-item>
          <el-breadcrumb-item>当前页面</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="pic">
     <div  v-html="productItem.Content" class="picImg">  </div>
    </div>
    <!-- <div class="productDown">
      <h6 class="productDownTitle">版本下载</h6>
      <div class="productDownItem" v-for="item in productDown" :key="item.ID">
        <p><span>{{item.Edition}}</span> <a :href='item.Path'>下载</a></p>
        <p>{{item.Info}}</p>
      </div>
   </div> -->
  </div>
</template>

<script>
import { getProductShow } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      productItem: {},
      productDown: {} // 下载
    }
  },
  watch: {
    '$route' () {
      this.getProductShow({ id: this.$route.params.id })
      // this.getProductDown({ id: this.$route.params.id })
    }
  },
  created () {
    this.getProductShow({ id: this.$route.params.id })
  },
  mounted () {

  },
  methods: {

    // 产品下载
    async getProductShow (data) {
      const res = await getProductShow(data)
      const base = request.defaults.baseURL
      const oldBase = '/Upload/Image/'
      if (res.Msg === '获取成功') {
        this.productItem = res.Data
        if (this.productItem.Content !== null) {
          this.productItem.Content = this.productItem.Content.replace(/\/Upload\/Image\//g, base + oldBase)
        }
        // this.productDown.forEach(item => {
        //   item.Path = request.defaults.baseURL + item.Path
        // })
      }
      // console.log(this.productItem, '111')
      // console.log(res, '下载')
    }
  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
  .title{
    display: flex;
    justify-content: space-between;
    // margin-top: 50px*$sun;
    width: 100%;
    color: #000;
    overflow: hidden;
    .breadcrumb{
        padding: 0 360px*$sun;
        font-size: 24px*$sun;
        font-weight: 500;
        margin-top: 50px*$sun;
    }
  }

.picBox{
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 500px*$sun;
  box-sizing: border-box;
}
.pic{
  width: 1200px*$sun;
  min-height: 600px*$sun;
  margin: 0 auto;
  // .picImg p{
  //   width: 100%;
  // }
}
::v-deep .picImg img{
  width: 100%;
}
// 产品下在
.productDown{
  width: 1200px*$sun;
  margin: 0 auto;
  font-size: 20px*$sun;
  .productDownTitle{
    font-size: 20px*$sun;
    border: 1px solid rgb(199, 200, 199);
    padding-top: 10px*$sun;
    padding-bottom: 10px*$sun;
  }
  .productDownItem{
    margin-top:20px*$sun;
    margin-bottom:20px*$sun;
  }
}
</style>
